var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container",style:({
    width: _vm.width + 'px',
    height: _vm.height + 'px',
    borderRadius: _vm.radius + 'px',
  })},[(_vm.src)?_c('img',{attrs:{"src":_vm.src},on:{"load":_vm.onImageLoad}}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }